var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button, Form, Input, message, Tabs, Upload } from 'antd';
import { List } from 'linqts';
import * as _ from 'lodash';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import ShowMore from 'react-show-more';
import ConstantField from 'src/shared/components/ConstantField';
import form from 'src/shared/decorators/form';
import Page from 'src/shared/layout/Page';
import services from 'src/shared/services/services';
import stores from 'src/stores/stores';
import DetailTabs from './DetailTabs';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {};
        _this.scores = [];
        _this.companyScores = [];
        _this.loading = true;
        _this.save = function () {
            _this.props.form.validateFields(function (errors, values) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!errors) return [3 /*break*/, 4];
                            this.loading = true;
                            return [4 /*yield*/, services.Company.save(this.model)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, services.Company.setStatus(this.model.id, 'Nihai Rapor')];
                        case 2:
                            _a.sent();
                            return [4 /*yield*/, services.Company.setBasariSirasi()];
                        case 3:
                            _a.sent();
                            document.getElementById('myFrame').contentWindow.location.reload();
                            message.success('Rapor oluşturuldu..');
                            this.loading = false;
                            _a.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
        };
        return _this;
    }
    default_1.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var id, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        id = this.props.match.params.id;
                        _a = this;
                        return [4 /*yield*/, services.Company.get(id)];
                    case 1:
                        _a.model = _d.sent();
                        if (!(stores.auth.hasRole('osb yetkilisi') || (this.model.status !== 'Nihai Rapor' && this.model.status !== 'Değerlendirmede'))) return [3 /*break*/, 2];
                        location.href = '/common/company';
                        return [3 /*break*/, 5];
                    case 2:
                        _b = this;
                        return [4 /*yield*/, services.Score.getAll(null, null)];
                    case 3:
                        _b.scores = _d.sent();
                        _c = this;
                        return [4 /*yield*/, services.CompanyScore.getScores(id)];
                    case 4:
                        _c.companyScores = _d.sent();
                        this.loading = false;
                        _d.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    default_1.prototype.render = function () {
        var _this = this;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        var users = [];
        if (!this.loading) {
            var userIds_1 = _.uniq(this.model.scores.map(function (c) { return c.userId; }));
            users = stores.user.model.filter(function (c) { return userIds_1.indexOf(c.id) > -1; });
        }
        var toplamPuan = 0.0;
        return (React.createElement(Page, { buttons: React.createElement("div", null,
                React.createElement(Button, { target: "_blank", href: '/api/common/companyservice/pdf/' + this.model.id }, "Nihai Raporu \u0130ndir"),
                React.createElement(Button, { loading: this.loading, type: "primary", onClick: this.save }, "Kaydet")), breadcrumbs: [{ link: '/common/company', text: 'Başvurular' }], loading: this.loading, title: 'Nihai Rapor: ' + this.model.name },
            React.createElement("div", { className: "card-body" },
                React.createElement(Form, { className: "row" },
                    React.createElement(Form.Item, { label: "Ba\u015Fvuru Sonu\u00E7", className: "col-md-6" }, getFieldDecorator('basvuruSonuc', {
                        initialValue: this.model.basvuruSonuc,
                        rules: [{ required: true, message: 'Alan zorunlu!' }]
                    })(React.createElement(ConstantField, { group: "firma.basvuru.sonuc", onChange: function (c) { return (_this.model.basvuruSonuc = Number(c)); } }))),
                    React.createElement(Form.Item, { label: "Tahsis Sonu\u00E7", className: "col-md-6" }, getFieldDecorator('tahsisSonuc', {
                        initialValue: this.model.tahsisSonuc,
                        rules: [{ required: true, message: 'Alan zorunlu!' }]
                    })(React.createElement(ConstantField, { group: "firma.basvuru.tahsis", onChange: function (c) { return (_this.model.tahsisSonuc = Number(c)); } }))),
                    React.createElement(Form.Item, { label: "Proje \u00D6zeti", className: "col-md-6" },
                        getFieldDecorator('projeOzeti', { initialValue: this.model.projeOzeti })(React.createElement(Input.TextArea, { rows: 8, maxLength: 1000, onChange: function (c) { return (_this.model.projeOzeti = c.target.value); } })),
                        React.createElement("span", { className: "ant-form-explain", style: { float: 'right' } },
                            (this.model.projeOzeti && this.model.projeOzeti.length) || 0,
                            " / 1000")),
                    React.createElement(Form.Item, { label: "De\u011Ferlendirme Notlar\u0131", className: "col-md-6" },
                        getFieldDecorator('degerlendirmeNotlari', { initialValue: this.model.degerlendirmeNotlari })(React.createElement(Input.TextArea, { rows: 8, maxLength: 2000, onChange: function (c) { return (_this.model.degerlendirmeNotlari = c.target.value); } })),
                        React.createElement("span", { className: "ant-form-explain", style: { float: 'right' } },
                            (this.model.degerlendirmeNotlari && this.model.degerlendirmeNotlari.length) || 0,
                            " / 2000"))),
                React.createElement("hr", null),
                React.createElement(DetailTabs, { startKey: 3, model: this.model, append: [
                        React.createElement(Tabs.TabPane, { key: 'nihaiRaporlar', tab: "N\u0130HA\u0130 RAPORLAR" },
                            React.createElement("div", { style: { marginBottom: 20 } },
                                React.createElement("div", { className: "row", style: { padding: '2px' } },
                                    React.createElement("div", { className: "col-md-6", style: { margin: '0 auto' } },
                                        React.createElement("div", { className: "card" },
                                            React.createElement("div", { className: "card-header bg-secondary", style: { padding: '6px 10px' } },
                                                React.createElement("div", { className: "card-title" }, "Nihai Raporlar")),
                                            React.createElement("ul", { className: "list-group list-group-flush border-top" }, this.model &&
                                                this.model.files &&
                                                this.model.files
                                                    .filter(function (c) { return c.categoryId === 10; })
                                                    .map(function (item) { return (React.createElement("a", { href: location.origin + '/uploads/' + item.companyId + '-' + item.id + item.extension, style: { padding: '6px 10px', borderRadius: '0' }, target: "_blank", key: item.id, className: "list-group-item list-group-item-action legitRipple" },
                                                    React.createElement("span", { className: "font-weight-semibold" },
                                                        " ",
                                                        item.name),
                                                    React.createElement("span", { className: "ml-auto" },
                                                        React.createElement("i", { style: { color: '#2196f3' }, className: "icon-download4 mr-2" })))); }))))))),
                        React.createElement(Tabs.TabPane, { key: 'ziyaretler', tab: "Z\u0130YARETLER" },
                            React.createElement("div", { style: { marginBottom: 20 } },
                                React.createElement(Upload, { listType: "picture-card", fileList: this.model.files &&
                                        this.model.files
                                            .filter(function (c) { return c.categoryId === 9; })
                                            .map(function (c) {
                                            return {
                                                uid: c.id,
                                                name: c.name,
                                                url: location.origin + '/uploads/' + _this.model.id + '-' + c.id + c.extension
                                            };
                                        }), action: location.origin + '/api/Common/CompanyService/FileUpload?companyId=' + this.model.id })))
                    ], prepend: [
                        React.createElement(Tabs.TabPane, { key: "1", tab: "De\u011Ferlendirme Raporu" },
                            React.createElement("iframe", { src: location.origin + '/api/common/companyservice/pdf2/' + this.props.match.params.id, id: "myFrame", style: { width: '100%', border: 'none', overflow: 'hidden', minHeight: '800px' }, onLoad: function () {
                                    var elem = document.getElementById('myFrame');
                                    elem.style.height = elem.contentWindow.document.body.scrollHeight + 'px';
                                } })),
                        React.createElement(Tabs.TabPane, { key: "2", tab: "De\u011Ferlendirici Puanlar\u0131" },
                            React.createElement("table", { className: "table table-bordered" },
                                React.createElement("thead", null,
                                    React.createElement("tr", null,
                                        React.createElement("th", null, "-"),
                                        React.createElement("th", null, "Ortalama"))),
                                React.createElement("tbody", null,
                                    this.scores.map(function (score) {
                                        var puan = new List(_this.model.scores)
                                            .Where(function (c) { return c.scoreId === score.id; })
                                            .Select(function (c) { return c.value; })
                                            .Average() * score.multiplier;
                                        toplamPuan += puan;
                                        return (React.createElement("tr", { key: score.id },
                                            React.createElement("th", null,
                                                score.name,
                                                " (%",
                                                (score.multiplier * 100).toFixed(0),
                                                ")"),
                                            React.createElement("th", null, puan.toFixed(2))));
                                    }),
                                    React.createElement("tr", null,
                                        React.createElement("th", null, "Toplam Puan"),
                                        React.createElement("th", null, toplamPuan.toFixed(2)))))),
                        React.createElement(Tabs.TabPane, { key: "3", tab: "\u00D6zet" },
                            React.createElement("table", { className: "table table-bordered" },
                                React.createElement("thead", null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { style: { width: '10%' } }),
                                        React.createElement("th", { style: { width: '40%' } }, "Proje \u00D6zeti"),
                                        React.createElement("th", { style: { width: '40%' } }, "De\u011Ferlendirme Notlar\u0131"))),
                                React.createElement("tbody", null, users.map(function (user) { return (React.createElement("tr", { key: user.id },
                                    React.createElement("th", null, user.name),
                                    React.createElement("td", null,
                                        React.createElement(ShowMore, { more: "G\u00F6ster", less: "Gizle" }, _.get(_.find(_this.model.notes, { userId: user.id }), 'projeOzeti'))),
                                    React.createElement("td", null,
                                        React.createElement(ShowMore, { more: "G\u00F6ster", less: "Gizle" }, _.get(_.find(_this.model.notes, { userId: user.id }), 'degerlendirmeNotlari'))))); })))),
                        React.createElement(Tabs.TabPane, { key: "", tab: "|", disabled: true })
                    ] }))));
    };
    __decorate([
        observable
    ], default_1.prototype, "model", void 0);
    __decorate([
        observable
    ], default_1.prototype, "scores", void 0);
    __decorate([
        observable
    ], default_1.prototype, "companyScores", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loading", void 0);
    default_1 = __decorate([
        form,
        observer
    ], default_1);
    return default_1;
}(React.Component));
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/app/common/company/Rapor.tsx
// module id = 1266
// module chunks = 0